import { render, staticRenderFns } from "./frontendRoleList.vue?vue&type=template&id=0df22990&scoped=true&"
import script from "./frontendRoleList.vue?vue&type=script&lang=js&"
export * from "./frontendRoleList.vue?vue&type=script&lang=js&"
import style0 from "./frontendRoleList.vue?vue&type=style&index=0&id=0df22990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df22990",
  null
  
)

export default component.exports